import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";

export interface AdminBadgeCounts {
  pendingOrders: number;
  paidOrders: number;
  total: number;
  loading: boolean;
}

export function useAdminBadgeCounts(): AdminBadgeCounts {
  const [counts, setCounts] = useState<AdminBadgeCounts>({
    pendingOrders: 0,
    paidOrders: 0,
    total: 0,
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;

    async function fetchCounts() {
      const { data, error } = await supabase
        .from("order_headers")
        .select("status", { count: "exact" });

      if (error || !data || cancelled) {
        if (!cancelled) {
          setCounts((prev) => ({ ...prev, loading: false }));
        }
        return;
      }

      const pending = data.filter((r) => r.status === "pending_payment").length;
      const paid = data.filter((r) => r.status === "paid").length;

      if (!cancelled) {
        setCounts({
          pendingOrders: pending,
          paidOrders: paid,
          total: pending + paid,
          loading: false,
        });
      }
    }

    fetchCounts();

    // Live sync for new orders
    const channel = supabase
      .channel("admin-badge-orders")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "order_headers" },
        () => {
          fetchCounts();
        }
      )
      .subscribe();

    return () => {
      cancelled = true;
      supabase.removeChannel(channel);
    };
  }, []);

  return counts;
}